import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar as MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ControltowerService } from 'src/app/services/dashboards/controltower.service';
import { PropertiesTowers } from 'src/app/services/dashboards/propertiesTower.service';

@Component({
  selector: 'neoris-modal-report-form-edit',
  templateUrl: './modal-report-form-edit.component.html',
  styleUrls: ['./modal-report-form-edit.component.css']
})
export class ModalReportFormEditComponent implements OnInit {
  reportForm:UntypedFormGroup = new UntypedFormGroup({})
  reportedBy:string=''
  arrayfieldServiceAgent:any[]=[]
  arrayReportStatus:any[]=[]
  private onLanChange: Subscription
  lang:string=''
  fieldServicesId:number=0
  fieldServicesRequest:any={}
  constructor(public dialogRef: MatDialogRef<ModalReportFormEditComponent>,
    private controltowerservice:ControltowerService,
    private translate: TranslateService,
    private _snackBar:MatSnackBar,private route: Router,
    private propertiesService:PropertiesTowers) { }

  get closingDate(){
    return this.formFields.get('closingDate') as UntypedFormControl
  }

  get affected(){
    return this.formFields.get('affected') as UntypedFormControl
  }

  get reportedby(){
    return this.formFields.get('reportedby') as UntypedFormControl
  }

  get reportField(){
    return this.formFields.get('reportField') as UntypedFormControl
  }

  get statusId(){
    return this.formFields.get('statusId') as UntypedFormControl
  }

  get siteId(){
    return this.formFields.get('siteId') as UntypedFormControl
  }

  get ReportDate(){
    return this.formFields.get('ReportDate') as UntypedFormControl
  }

  get agent(){
    return this.formFields.get('agent') as UntypedFormControl
  }

  get reasonId(){
    return this.formFields.get('reasonId') as UntypedFormControl
  }

  get aditional(){
    return this.formFields.get('aditional') as UntypedFormControl
  }

  get reportedCloseby(){
    return this.formFields.get('reportedCloseby') as UntypedFormControl
  }


  formFields = new UntypedFormGroup({
    'closingDate': new UntypedFormControl(''),
    'affected':new UntypedFormControl(''),
    'reportedby':new UntypedFormControl(''),
    'reportField':new UntypedFormControl(''),
    'statusId':new UntypedFormControl(''),
    'siteId':new UntypedFormControl(''),
    'ReportDate':new UntypedFormControl(''),
    'agent':new UntypedFormControl(''),
    'reasonId':new UntypedFormControl(''),
    'aditional':new UntypedFormControl(''),
    'reportedCloseby':new UntypedFormControl(''),
    'fieldAgent':new UntypedFormControl(''),


    
    
    

    
    
    



  });


  ngOnInit(): void {
     
    this.onLanChange = this.translate.onLangChange.subscribe(s => {
      console.log("idioma",s.lang)
      this.lang = s.lang != undefined ? s.lang : "en";
      this.getGenericAtrributeValue(this.lang)
      
    })

    if(this.lang == undefined || this.lang==''){
      this.getGenericAtrributeValue('en')
    }

    const dataFieldService = JSON.parse(localStorage.getItem('rowFieldServicesReview'))
    console.log('datos del row seleccionado',dataFieldService)
    this.fieldServicesId = dataFieldService.FieldServicesId

    this.formFields.controls['ReportDate'].setValue(this.formatDate(dataFieldService.ReportedDate))
    this.formFields.controls['affected'].setValue(dataFieldService.AffecteddServices)
    this.formFields.controls['reportedby'].setValue(dataFieldService.ReportedBy)
    this.formFields.controls['statusId'].setValue(dataFieldService.StatusId)
    this.formFields.controls['siteId'].setValue(dataFieldService.Site)
    this.formFields.controls['reasonId'].setValue(dataFieldService.Reason)

    this.formFields.controls['aditional'].setValue(dataFieldService.AdditionalInformation)

    this.formFields.controls['agent'].setValue(dataFieldService.AgentComments)
    this.formFields.controls['fieldAgent'].setValue(dataFieldService.FieldServicesAgent)

    console.log('fecha closed--->',dataFieldService.ClosedDate)
    this.formFields.controls['closingDate'].setValue(this.formatDate(dataFieldService.ClosedDate))

    this.formFields.controls['reportedCloseby'].setValue(dataFieldService.ClosedBy)
    

  }

  private formatDate(date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
  }


  async save(){
    console.log('data a enviar',this.formFields)

    this.fieldServicesRequest.fieldServiceRequestId =this.fieldServicesId
    this.fieldServicesRequest.fieldServiceAgent = this.formFields.value.fieldAgent
    this.fieldServicesRequest.agentComments = this.formFields.value.agent
    this.fieldServicesRequest.statusId = this.formFields.value.statusId


    console.log('send request---->',this.fieldServicesRequest)
    let result = await this.UpdateReportFieldsServicesReview(this.fieldServicesRequest)
    console.log('response',result)

    if(result){
      console.log('entre en uno')
      this.openSnackBar(this.translate.instant('ALERT_SUCCESS'),"OK")
      this.dialogRef.close()
      this.propertiesService.setConfirmFieldsServicesUpdate(true)
    }
    else{
      console.log('entre en dos')
      this.openSnackBar(this.translate.instant('ALERT_FAILED'),"FAILED")
      this.dialogRef.close()
    }

  }

  close(){
    this.dialogRef.close()
  }

  openSnackBar(message: string, action: string) {
    if(action == 'OK'){
    this._snackBar.open(message, action, {
      duration: 5000,
      panelClass: ['blue-snackbar']
    });
  }
  else{
    this._snackBar.open(message, action, {
      duration: 5000,
      panelClass: ['blue-snackbar-false']
    });
  }
  }



  private async UpdateReportFieldsServicesReview(request:any): Promise<any> {
    
    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.UpdateFieldsServicesReview(request).subscribe(
        {
          next: (updatereport: any) => {
            console.log('respondio el save update reporte--->:',updatereport);
                                  
            resolve(updatereport);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }

  private async getGenericAtrributeValue(localCode:string): Promise<boolean> {
   

    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.getAttributeValue(localCode).subscribe(
        {
          next: (attribute: any={}) => {
            console.log('si entre----->',attribute)
            for(let i=0;i<= attribute.attributeTypes.length -1;i++){
              if(attribute.attributeTypes[i].id == 52){
                console.log('si entre----->')
                this.arrayReportStatus = attribute.attributeTypes[i].attributeValues

              }
             
              
            

            }
           
            
            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }


}
